import PropTypes from 'prop-types'
import { Table } from 'baseui/table-semantic'
import { useTranslation } from 'react-i18next'
import { SIZE } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'

const AssistanceList = ({ items, page, elementsPerPage, updateAssistance }) => {
  const { t } = useTranslation()
  const COLUMNS = [
    t('assistanceConfiguration:name'),
    t('assistanceConfiguration:price'),
    t('assistanceConfiguration:status'),
    t('assistanceConfiguration:zoho_id'),
    t('common:edit'),
  ]
  const transformAssistance = assistanceList => {
    if (!assistanceList) {
      return []
    }
    let elements = assistanceList.map(assistance => {
      const attributes = assistance.attributes
      return [
        assistance.name,
        attributes.price,
        parseInt(attributes.status) === 1
          ? t('assistanceConfiguration:status_active')
          : t('assistanceConfiguration:status_inactive'),
        assistance.zoho_id,
        <SDButton key={assistance.id} block={true} size={SIZE.compact} onClick={() => updateAssistance(assistance)}>
          {t('common:edit')}
        </SDButton>,
      ]
    })
    elements = elements.slice((page - 1) * elementsPerPage, page * elementsPerPage)
    return elements
  }
  return <Table columns={COLUMNS} data={transformAssistance(items)} />
}

AssistanceList.propTypes = {
  items: PropTypes.array,
  page: PropTypes.number,
  elementsPerPage: PropTypes.number,
  updateAssistance: PropTypes.func,
}
export default AssistanceList
